/**
 * F1-SignIn — entry. Email OTP. Sets expectations for the whole flow.
 * Copy close to the artboard; styling from tokens.
 */
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { requestOtp, ApiError } from '../lib/api';

export function SignIn(): JSX.Element {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: React.FormEvent): Promise<void> {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const { session } = await requestOtp(email);
      // Carry email + session to the verify screen.
      navigate('/verify', { state: { email, session } });
    } catch (err) {
      setError(err instanceof ApiError ? 'Could not send a code. Check the address and try again.' : 'Something went wrong.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="flow flow--single">
      <div className="stage-card">
        <h1>Let&rsquo;s get you an estimate.</h1>
        <p className="stage-card__lede">
          Send a few photos and answer a few questions. We&rsquo;ll come back with a free
          estimate &mdash; no visit needed. First, your email so you can pick this back up
          any time.
        </p>
        <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 'var(--pb-3)' }}>
          <label className="pb-label" htmlFor="email">
            Email address
          </label>
          <input
            id="email"
            className="pb-field"
            type="email"
            required
            autoComplete="email"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {error ? (
            <div className="pb-note pb-note--flag" role="alert">
              {error}
            </div>
          ) : null}
          <button type="submit" className="pb-btn pb-btn--lg" disabled={busy || !email}>
            {busy ? 'Sending a code\u2026' : 'Send me a code'}
          </button>
          <p className="estimate__hint">We&rsquo;ll email a one-time code. No password to remember.</p>
        </form>
      </div>
    </div>
  );
}
